import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit, ViewEncapsulation, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { FormDataService } from '@app/_core/services/form-data.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { OutboundComponent } from '@app/pages/queue/outbound/outbound.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-add-record',
  templateUrl: './add-record.component.html',
  styleUrl: './add-record.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AddRecordComponent implements OnInit {
  selectedUserID: any;
  clientAbbreviation: string;

  constructor(
    private fb: FormBuilder,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private appService: AppService,
    private queueServices: QueuesService,
    private cdref: ChangeDetectorRef,
    private outboundComponent: OutboundComponent
  ) {}

  @Input()
  Heading: any;
  user: any;
  company: any;
  showSearch: boolean;
  activityId: any;
  userId: any;
  queueID: any;
  modalRef?: BsModalRef;

  ngOnInit(): void {
    this.handleSelectedUser(null);
    this.showSearch = true;
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.company = this.webStorageService.getItemFromSessionStorage('company');
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueID = queueId;
    });
  }
  handleSelectedUser(event) {
    console.log(event)
   if(event == 'not-found'){
      const initialState = {
        contentMsg: 'This will create a new user record. Are you sure you would like to continue?',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
        isConfirm: true,
        isDelete: false,
      };

      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          console.log('create')
          this.bsModalRef.hide();
          // const actionItem = this.getActionItem();
          this.appService.setActionItemId(this.queueID + "-" + null + "-" + 0);
          this.appService.setIsAddNewUser(true);
          this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
        } else {
          this.modalRef.hide();
        }
        this.modalRef.hide();
      });


    }
  }
  handleSelectedExisistingUser(event){
    if (event && event.length == 1 && event != 'not-found') {
      this.Heading = '';
      this.selectedUserID = event[0].UserID;
      // this.selectedCaseId = null;
      this.showSearch = false;
      this.bsModalRef.hide();

      // this.fullName = event[0].FullName
      const data = {
        queueID: this.queueID,
        userID: this.selectedUserID,
        company: this.company,
        user: this.user,
      };
      this.managerService.addExistingRecord(data).subscribe(res => {
        console.log(res);

        if (res) {
          this.bsModalRef.hide();

          const initialState = {
            contentMsg: 'Your requested record has been added to the queue.',
            confirmBtnValue: 'Ok',
            cancelBtnValue: '',
            isConfirm: true,
            isDelete: false,
          };

          const config: ModalOptions = {
            backdrop: 'static',
            class: 'confirm-dialog modal-wd-290',
            initialState,
          };

          this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
          this.modalRef.content.event.subscribe((result: any) => {
            if (result.value == 'confirm') {
              console.log('create');
              this.modalRef.hide();
              this.managerService.recordAdded.emit(res);
              // this.outboundComponent.loadQueues();
              // alert('hi')
              // this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
            }
          });
          this.bsModalRef.hide();
        }
      });
    }
  }
  closeCaseCreation() {
    this.bsModalRef.hide();
  }
}
